import React from "react";
import { Box, Typography, Button, Modal } from "@mui/material";
import { styled } from "@mui/system";
import Gradient from "../assets/gradient2.png";
import LogoImg from "../assets/logo.png";
import LogoImgShort from "../assets/logo_short.png";
import LogoImgShortDark from "../assets/trans_logo_short.png";
import AppleIcon from "@mui/icons-material/Apple";
import { COLORS } from "../utils/COLORS";
import { Pets } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Discord } from "@mui/icons-material";
import IdeaIcon from "@mui/icons-material/Lightbulb";
import { motion } from "framer-motion";
import { Stepper, Step, StepLabel, StepContent } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PetsIcon from "@mui/icons-material/Pets";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Avatar from "@mui/material/Avatar";
import CreateIcon from "@mui/icons-material/Create";
import MoneyIcon from "@mui/icons-material/Money";
import UpdateIcon from "@mui/icons-material/Update";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import AnalyticsIcon from "@mui/icons-material/Analytics";

const StyledModal = styled(Modal)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "center",
}));

const ModalContent = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderTopLeftRadius: theme.shape.borderRadius,
  borderTopRightRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[5],
  padding: theme.spacing(4),
  outline: "none",
  width: "90%",
  maxWidth: "400px",
  maxHeight: "80vh",
  overflowY: "auto",
  textAlign: "center",
}));

const Background = styled(Box)({
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundColor: COLORS.yellow,
  height: "100vh",
  overflowX: "hidden",
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  position: "relative",
});

const Logo = styled("img")({
  width: "150px",
  marginBottom: "20px",
  paddingTop: "10%",
});

const Subtitle = styled(Typography)({
  marginBottom: "20px",
  color: "#fff",
});

const Terms = styled(Typography)({
  bottom: "14px",
  fontSize: "12px",
  cursor: "pointer",
  color: "#000",
});

const LandingPage = () => {
  const navigate = useNavigate();
  const [isMobileView, setIsMobileView] = React.useState(
    window.innerWidth < 600
  );
  const [showHowitWorksModal, setShowHowitWorksModal] = React.useState(false);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 600);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const steps = [
    {
      label: "Define Your Ideal Husband",
      description:
        "Tell us about your dream partner - from personality traits to lifestyle preferences.",
      icon: <CreateIcon />,
    },
    {
      label: "Discover Local Hotspots",
      description:
        "Get personalized recommendations for events and venues where your ideal match might hang out.",
      icon: <RestaurantIcon />,
    },
    {
      label: "Track Your Journey",
      description:
        "Keep track of places you've visited and potential matches you've met along the way.",
      icon: <MonitorHeartIcon />,
    },
    {
      label: "Community Insights",
      description:
        "Learn from other women's experiences and success stories in your area.",
      icon: <AnalyticsIcon />,
    },
  ];

  const renderHowitWorksModal = () => {
    return (
      <StyledModal
        open={showHowitWorksModal}
        onClose={() => setShowHowitWorksModal(false)}
        BackdropProps={{
          style: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
        }}
      >
        <motion.div
          onClick={() => setShowHowitWorksModal(false)}
          initial={{ y: isMobileView ? "100%" : 0 }}
          animate={{ y: 0 }}
          exit={{ y: isMobileView ? "100%" : 0 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: isMobileView ? "flex-end" : "center",
            height: "100%",
          }}
        >
          <ModalContent
            sx={{
              height: isMobileView ? "63vh" : "auto",
              maxHeight: isMobileView ? "80vh" : "90vh",
            }}
          >
            <Typography variant="h5" gutterBottom align="center">
              How it works
            </Typography>
            <Typography variant="body1" paragraph align="center">
              HusbandHotspots helps you find your ideal partner in real life by
              connecting you with the right places and events.
            </Typography>

            <Stepper orientation="vertical">
              {steps.map((step, index) => (
                <Step key={step.label} active={true}>
                  <StepLabel
                    StepIconComponent={() => (
                      <Avatar
                        sx={{
                          bgcolor: COLORS.secondary,
                          width: 32,
                          height: 32,
                        }}
                      >
                        {step.icon}
                      </Avatar>
                    )}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: "bold", color: "text.primary" }}
                    >
                      {step.label}
                    </Typography>
                  </StepLabel>
                  <StepContent>
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary", textAlign: "left" }}
                    >
                      {step.description}
                    </Typography>
                  </StepContent>
                </Step>
              ))}
            </Stepper>

            <Button
              fullWidth
              variant="contained"
              onClick={() => (window.location.href = "/mission")}
              sx={{
                width: "100%",
                mt: 5,
                backgroundColor: COLORS.blue,
                color: "#ffffff",
                fontWeight: "bold",
                fontSize: "18px",
                padding: "16px",
                mb: 1,
                borderRadius: "12px",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: COLORS.darkGreen,
                  boxShadow: "0 6px 12px rgba(0, 0, 0, 0.2)",
                },
                "&:active": {
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                },
                "&:focus": {
                  backgroundColor: COLORS.primaryGreen,
                },
              }}
            >
              OUR MISSION
            </Button>
            <Typography
              variant="button"
              onClick={() => setShowHowitWorksModal(false)}
              sx={{ mt: 3, color: "black", cursor: "pointer" }}
            >
              Close
            </Typography>
          </ModalContent>
        </motion.div>
      </StyledModal>
    );
  };

  return (
    <Background>
      {renderHowitWorksModal()}
      <Logo src={LogoImgShort} alt="Logo" />
      <Typography
        variant="h1"
        style={{
          color: "#000",
          fontWeight: "bold",
          fontSize: isMobileView ? "2rem" : "3rem",
        }}
      >
        HusbandHotspots
      </Typography>
      <Subtitle
        variant="h6"
        style={{
          color: "#000",
          marginBottom: "20px",
          textAlign: "center",
          fontSize: isMobileView ? "1rem" : "1.25rem",
          width: isMobileView ? "80%" : "50%",
        }}
      >
        Find Your Ideal Husband IRL
      </Subtitle>

      <Subtitle
        variant="h6"
        style={{
          color: "#000",
          marginBottom: "20px",
          fontSize: isMobileView ? "1rem" : "1.25rem",
          width: isMobileView ? "80%" : "50%",
        }}
      >
        Discover local events you're most likely to meet your husband
      </Subtitle>
      {/* <Button
        onClick={() => setShowHowitWorksModal(true)}
        variant="contained"
        color="primary"
        sx={{
          marginTop: "20px",
          backgroundColor: "white",
          color: "black",
          fontWeight: "bold",
          textTransform: "none",
          padding: "10px 26px",
          borderRadius: "10px",
          "&:hover": {
            backgroundColor: COLORS.blue,
          },
          width: isMobileView ? "80%" : "250px",
        }}
        startIcon={<IdeaIcon sx={{ color: "black" }} />}
      >
        How it works
      </Button> */}
      <Button
        onClick={() => window.open("https://apps.apple.com/", "_blank")}
        variant="contained"
        color="primary"
        sx={{
          marginTop: "20px",
          backgroundColor: COLORS.blue,
          color: "#ffffff",
          fontWeight: "bold",
          textTransform: "none",
          padding: "10px 26px",
          borderRadius: "10px",
          "&:hover": {
            backgroundColor: COLORS.blue,
          },
          width: isMobileView ? "80%" : "250px",
        }}
        startIcon={<AppleIcon sx={{ color: "white" }} />}
      >
        Download on App Store
      </Button>
      <Typography
        sx={{
          color: COLORS.lightGray4,
          fontSize: "1rem",
          textAlign: "center",
          marginTop: "5px",
          marginBottom: "20px",
          width: isMobileView ? "100%" : "50%",
        }}
      >
        Free to download, premium features available
      </Typography>

      <Box
        sx={{
          position: "absolute",
          bottom: 5,
          left: 0,
          right: 0,
          marginTop: isMobileView ? "70px" : "0",
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-evenly",
            width: isMobileView ? "90vw" : "40vw",
          }}
        >
          <Terms
            onClick={() => (window.location.href = "/privacy")}
            variant="body2"
            sx={{
              marginBottom: isMobileView ? "10px" : 0,
              color: COLORS.lightGray4,
            }}
          >
            Privacy Policy
          </Terms>

          <Terms
            onClick={() =>
              (window.location.href = "mailto:contact@husbandhotspots.com")
            }
            variant="body2"
            style={{ color: COLORS.lightGray4 }}
          >
            Contact Us
          </Terms>
        </Box>
      </Box>
    </Background>
  );
};

const styles = {
  appContainer: {
    marginTop: "20px",
    display: "flex",
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-evenly",
  },
  itemContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default LandingPage;
